import { render, staticRenderFns } from "./notif.vue?vue&type=template&id=eabf5bd4"
import script from "./notif.vue?vue&type=script&lang=js"
export * from "./notif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eabf5bd4')) {
      api.createRecord('eabf5bd4', component.options)
    } else {
      api.reload('eabf5bd4', component.options)
    }
    module.hot.accept("./notif.vue?vue&type=template&id=eabf5bd4", function () {
      api.rerender('eabf5bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/notif/notif.vue"
export default component.exports